import React, { Component } from 'react';
import TableC from '../../basicElement/TableC';
import '../style/home.less';

class MainContent extends Component {
    getRender = (text, record) => {
        const obj = {
            children: text,
            props: {},
        };
        if (record.rowSpan) {
            obj.props.rowSpan = record.rowSpan;
        } else {
            obj.props.rowSpan = 0;
        }
        if (record.colSpan) {
            obj.props.colSpan = record.colSpan;
        }
        if (text.startsWith('合计')) {
            obj.children = <strong>{text}</strong>;
        }
        return obj;
    }

    getMainColumns = () => ([
        {
            title: '考核项',
            dataIndex: 'performanceScoreName',
            key: 'performanceScoreName',
            width: 380,
            render: this.getRender,
        }, {
            title: '细项',
            dataIndex: 'minorItem',
            key: 'minorItem',
            width: 380,
            render: (text, record) => {
                const obj = {
                    children: text,
                    props: {},
                };
                if (!record.minorItem) {
                    obj.props.colSpan = 0;
                }
                return obj;
            }
        }, {
            title: '得分',
            dataIndex: 'scoreValue',
            key: 'scoreValue',
            width: 370,
            render: (text, record) => {
                if (record.performanceScoreName.startsWith('合计')) {
                    return <strong>{text}</strong>;
                }
                return text;
            }
        }
    ])

    getMainDataSource = () => {
        const { mianList } = this.props;
        let key = 1;
        let dataSource = [];
        mianList.forEach(item => {
            if (item.childrens && item.childrens.length > 0) {
                item.childrens.forEach((childItem, childIndex) => {
                    dataSource.push({
                        key,
                        ...item,
                        rowSpan: !childIndex ? item.childrens.length : 0,
                        scoreValue: childItem.scoreValue,
                        minorItem: childItem.performanceScoreName,
                        performanceScoreId: childItem.performanceScoreId,
                    });
                    key++;
                });
            } else {
                if (item.performanceScoreName.startsWith('合计')) {
                    dataSource.push({
                        key,
                        ...item,
                        rowSpan: 1,
                        colSpan: 2,
                    });
                } else {
                    dataSource.push({
                        key,
                        ...item,
                        rowSpan: 1,
                        minorItem: '-',
                    });
                }
                key++;
            }
        });
        return dataSource;
    }

    getColumns = () => ([
        {
            title: '',
            dataIndex: 'configName',
            key: 'configName',
            width: 100,
            fixed: 'left',
            className: 'theme-color',
            render: (text, record) => {
                const obj = {
                    props: {},
                    children: text,
                };
                if (record.rowSpan) {
                    obj.props.rowSpan = record.rowSpan;
                } else {
                    obj.props.rowSpan = 0;
                }
                if (record.colSpan) {
                    obj.props.colSpan = record.colSpan;
                }
                return obj;
            }
        }, {
            title: '',
            dataIndex: 'configValue',
            key: 'configValue',
            width: 100,
            fixed: 'left',
            className: 'theme-color',
            render: (text, record) => {
                const obj = {
                    props: {},
                    children: text,
                };
                if (!record.configValue) {
                    obj.props.colSpan = 0;
                }
                return obj;
            }
        }, {
            title: '项目分类',
            children: [
                {
                    title: '肿瘤注册研究',
                    dataIndex: 'tumourVisitCount',
                    key: 'tumourVisitCount',
                    width: 100,
                }, {
                    title: '危急症注册研究',
                    dataIndex: 'criticalVisitCount',
                    key: 'criticalVisitCount',
                    width: 100,
                }, {
                    title: '其他药物注册研究',
                    dataIndex: 'otherDrugsVisitCount',
                    key: 'otherDrugsVisitCount',
                    width: 100,
                }, {
                    title: 'I期患者研究',
                    dataIndex: 'onePatientVisitCount',
                    key: 'onePatientVisitCount',
                    width: 100,
                }, {
                    title: 'I期健康人研究',
                    dataIndex: 'oneHealthyVisitCount',
                    key: 'oneHealthyVisitCount',
                    width: 100,
                }, {
                    title: 'BE研究',
                    dataIndex: 'beVisitCount',
                    key: 'beVisitCount',
                    width: 100,
                }, {
                    title: '上市后IV期研究',
                    dataIndex: 'listingFourVisitCount',
                    key: 'listingFourVisitCount',
                    width: 100,
                }, {
                    title: '医疗器械研究',
                    dataIndex: 'diagnosisVisitCount',
                    key: 'diagnosisVisitCount',
                    width: 100,
                }, {
                    title: '观察性研究或研究者发起或回顾性或流行病学研究',
                    dataIndex: 'observabilityVisitCount',
                    key: 'observabilityVisitCount',
                    width: 120,
                }, {
                    title: '诊断试剂研究',
                    dataIndex: 'diagnosticReagentVisitCount',
                    key: 'diagnosticReagentVisitCount',
                    width: 120,
                }, {
                    title: '疫苗研究',
                    dataIndex: 'vaccineResearchVisitCount',
                    key: 'vaccineResearchVisitCount',
                    width: 100,
                }, {
                    title: '研究者发起研究',
                    dataIndex: 'rsearchersInitiateVisitCount',
                    key: 'rsearchersInitiateVisitCount',
                    width: 120,
                }, {
                    title: 'NA',
                    dataIndex: 'naVisitCount',
                    key: 'naVisitCount',
                    width: 100,
                }
            ]
        }
    ])

    render() {
        const { loading, fteColumns, fteDataSource, dataSource } = this.props;
        return (
            <div>
                <div style={{ lineHeight: '48px' }}>1.主要业绩分明细</div>
                <TableC
                    loading={loading}
                    columns={this.getMainColumns()}
                    data={this.getMainDataSource()}
                    className="mainPerformance"
                    rowKey="key"
                />
                <div style={{ lineHeight: '48px' }}>2.FTE情况</div>
                <TableC
                    loading={loading}
                    columns={fteColumns}
                    data={fteDataSource}
                    className="fte"
                />
                <div style={{ lineHeight: '48px' }}>3.以CRC角色参与的项目数量、消耗的FTE、完成访视数的情况</div>
                <TableC
                    scrollY={300}
                    loading={loading}
                    columns={this.getColumns()}
                    data={dataSource}
                    className="visit"
                />
            </div>
        );
    }
}

export default MainContent;



// WEBPACK FOOTER //
// ./src/components/home/performanceDetail/MainContent.js